import React, { useEffect, useRef, useState } from 'react';
import { IdType } from 'react-table';
import { RowData } from 'views/MTable/Table.model';
import MQuickFiltersButtonView from './MQuickFiltersButton.view';
import { MQuickFiltersListPosition } from './MQuickFiltersButton.model';

type FilterJSX<T> = {
  id: IdType<T>;
  jsxFunc: () => React.ReactNode;
};

type Props<T extends RowData> = {
  filtersJSX?: FilterJSX<T>[];
  className?: string;
  position?: MQuickFiltersListPosition;
  loading?: boolean;
};

const MQuickFiltersButton = <T extends RowData>(props: React.PropsWithChildren<Props<T>>): JSX.Element => {
  const [btnFilterState, setBtnFilterState] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (btnFilterState && dropdownRef.current) {
      const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && dropdownRef.current !== event.target && !dropdownRef.current.contains(event.target as HTMLElement)) {
          setBtnFilterState(() => false);
        }
      };

      document.addEventListener('click', handleClickOutside);

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [btnFilterState, dropdownRef, setBtnFilterState]);

  return (
    <MQuickFiltersButtonView
      loading={props.loading}
      filtersJSX={props.filtersJSX}
      dropdownRef={dropdownRef}
      btnFilterState={btnFilterState}
      onClickBtnFilter={() => setBtnFilterState((prev: boolean) => !prev)}
      className={props.className}
      position={props.position}
    ></MQuickFiltersButtonView>
  );
};

MQuickFiltersButton.displayName = 'MQuickFiltersButton';

export default MQuickFiltersButton;
